import { Container } from "@/components/layout/container";
import logo from "@/assets/logo-cineblocks-1.svg";
import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import { StepIndicator } from "@/components/ui/step-indicator";
import { ReactNode, useEffect, useState } from "react";
import { ProjectAbout } from "@/components/project-registration/project-about";
import { ProjectDetails } from "@/components/project-registration/project-details";
import { ProjectView } from "@/components/project-registration/project-view";

import { useGetProjects } from "@/services/queries/useProject";

export function ProjectRegistration() {
  const [currentStep, setCurrentStep] = useState(1);
  const [projectId, setProjectId] = useState(0);
  const [completedSteps] = useState<Array<number>>([1, 2, 3, 4]);

  const handleBack = () => setCurrentStep(p => p - 1)
  const handleContinue = () => setCurrentStep(p => p + 1)

  const { data: projects } = useGetProjects()

  const stepsComponents: Record<number, ReactNode> = {
    1: <ProjectAbout onContinue={handleContinue} setProjectId={setProjectId} initialData={projects?.[0]} />,
    2: <ProjectDetails onContinue={handleContinue} projectId={projectId} />,
    3: <ProjectView projectId={projectId} />,
  }

  useEffect(() => {
    if (projects && projects?.length > 0) {
      setProjectId(projects[0]?.id)
    }
  }, [projects])

  return (
    <div className="min-h-screen bg-[#0c1427]">
      <Container>
        <div className="max-w-[1488px] mx-auto px-4 py-8">
          <div className="flex items-center justify-between mb-12">


            <div className="flex items-center gap-2 absolute left-1/2 -translate-x-1/2">
              <img src={logo} alt="Logo Cineblocks" className="w-10 h-10" />
              <span className="text-2xl font-bold">cineblocks</span>
            </div>
          </div>

          <StepIndicator
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            totalSteps={3}
            completedSteps={completedSteps}
          />

          <div className="text-center mb-10">
            <h2 className="text-[32px] font-bold text-white mb-3 font-['Plus_Jakarta_Sans']">
              Cadastro de Novo Projeto
            </h2>

            <p className="text-[#e7e7e7] text-base font-['Plus_Jakarta_Sans']">
              Preencha os dados principais referente ao projeto.
            </p>
          </div>

          {stepsComponents[currentStep]}
        </div>
      </Container>
    </div>
  )
}